import { Button } from "@backslashbuild/pp-ui";
import React from "react";

export default function SyncButton({ onClick }) {
  return (
    <Button
      large
      onClick={() => {
        onClick();
      }}
    >
      Get Notifications
    </Button>
  );
}
